module.exports = __webpack_public_path__ + "img/jingzhuang4.d6457be3.jpg";